import { render, staticRenderFns } from "./WorkshopViewAll.vue?vue&type=template&id=61ac1ce8&scoped=true&lang=pug&"
import script from "./WorkshopViewAll.vue?vue&type=script&lang=js&"
export * from "./WorkshopViewAll.vue?vue&type=script&lang=js&"
import style0 from "./WorkshopViewAll.vue?vue&type=style&index=0&id=61ac1ce8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ac1ce8",
  null
  
)

export default component.exports